module.exports = __webpack_public_path__ + "static/render1wide-4e55eda3ffb9b5c22d3795dfbbef25ab.png";